import { IMenu } from '../models'
import CONFIG from '../../config'

const menu: IMenu[] = [
  {
    id: 11,
    name: 'Inicio',
    icon: 'home',
    url: CONFIG.ROUTES.DASHBOARD.HOME,
    favoriteShow: false
  },
  {
    id: 1,
    name: 'Mi Grupo familiar',
    icon: 'mi-grupo-familiar',
    url: CONFIG.ROUTES.DASHBOARD.FAMILYGROUP.HOME,
    favoriteShow: true
  },
  {
    id: 4,
    name: 'Mi Historial médico',
    icon: 'mi-historial-medico',
    url: CONFIG.ROUTES.DASHBOARD.MEDICALAPPOINTMENTS.HOME,
    favoriteShow: true,
    children: [
      {
        id: 41,
        name: 'Consultas médicas',
        icon: '',
        url: CONFIG.ROUTES.DASHBOARD.MEDICALAPPOINTMENTS.HOME
      },
      {
        id: 42,
        name: 'Solicitar documentos',
        icon: '',
        url: CONFIG.ROUTES.DASHBOARD.MEDICALAPPOINTMENTS.REQUESTDOCUMENTS
      }/*,
      {
        id: 43,
        name: 'Hospitalizaciones',
        icon: ',
        url: '/dashboard/mi-historial-medico/hospitalizaciones'
      },
      {
        id: 44,
        name: 'Urgencias',
        icon: ',
        url: '/dashboard/mi-historial-medico/urgencias'
      } */
    ]
  },
  {
    id: 7,
    name: 'Solicitudes',
    icon: 'solicitudes',
    url: CONFIG.ROUTES.DASHBOARD.REQUESTS,
    favoriteShow: true
  },
  {
    id: 2,
    name: 'Mis Exámenes',
    icon: 'mis-examenes',
    url: CONFIG.ROUTES.DASHBOARD.EXAMSPROCEDURES.HOME, // '/dashboard/mis-examenes/laboratorio',
    favoriteShow: true,
    children: [
      {
        id: 21,
        name: 'Laboratorio',
        icon: '',
        url: CONFIG.ROUTES.DASHBOARD.EXAMSPROCEDURES.LABORATORY
      },
      {
        id: 22,
        name: 'Imágenes y procedimientos',
        icon: '',
        url: CONFIG.ROUTES.DASHBOARD.EXAMSPROCEDURES.OTHEREXAMS
      },
      {
        id: 23,
        name: 'Plazos de visualización',
        icon: '',
        url: CONFIG.ROUTES.DASHBOARD.EXAMSPROCEDURES.DISPLAYDURATION
      }
    ]
  },
  /* {
    id: 5,
    name: 'Mis Cuentas',
    icon: 'mis-cuentas',
    url: '',
    favoriteShow: true,
    children: [
      {
        id: 51,
        name: 'Hospitalizaciones',
        icon: '',
        url: '/dashboard/mis-cuentas/hospitalizaciones'
      },
      {
        id: 52,
        name: 'Urgencias',
        icon: '',
        url: '/dashboard/mis-cuentas/urgencias'
      }
    ]
  }, */
  /* {
    id: 8,
    name: 'Vacunatorio',
    icon: 'vacunatorio',
    url: '/dashboard/vacunatorio',
    favoriteShow: true,
    children: [
      {
        id: 81,
        name: 'Mis vacunas',
        icon: '',
        url: '/dashboard/vacunatorio/mis-vacunas'
      },
      {
        id: 82,
        name: 'Stock de vacunas',
        icon: '',
        url: '/dashboard/vacunatorio/stock-vacunas'
      }
    ]
  }, */
  {
    id: 3,
    name: 'Control y Prevención',
    icon: 'control-prevencion',
    url: CONFIG.ROUTES.DASHBOARD.CONTROLPREVENTION,
    favoriteShow: true
  },
  /* {
    id: 6,
    name: 'Convenios y Seguros',
    icon: 'convenios-seguros',
    url: '/dashboard/convenios-seguros',
    favoriteShow: true
  }, */
  {
    id: 9,
    name: 'Solicitud de presupuestos',
    icon: 'solicitud-presupuestos',
    url: CONFIG.ROUTES.DASHBOARD.BUDGETREQUEST,
    favoriteShow: true
  },
  {
    id: 10,
    name: 'Contáctanos',
    icon: 'contact',
    url: CONFIG.ROUTES.DASHBOARD.CONTACT,
    favoriteShow: true
  }
];

export default menu;
